/* eslint-disable max-len */
export const LINK_URL_TEXT = 'Share this link with your participants.';

export const DEFAULT_TEXT = 'Send this link to participants. They will record and upload their sessions. We provide participants with brief instructions on taking video sessions. View instructions ';
